module.exports = __webpack_public_path__ + "img/estatusCambio de tratamiento.eb502fdf.png";